class HtbVideoModal extends HTMLElement {
  connectedCallback() {
    this.mediaEl = this.querySelector('.htb-video-modal__media');
    this.querySelector('.htb-video-modal__backdrop')?.addEventListener('click', () => this.close());
    this.querySelector('.htb-video-modal__close')?.addEventListener('click', () => this.close());
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !this.hidden) this.close();
    });
  }

  open(videoUrl, videoFileUrl) {
    this.mediaEl.innerHTML = '';

    if (videoUrl) {
      const embedUrl = this._embedUrl(videoUrl);
      if (embedUrl) {
        const iframe = document.createElement('iframe');
        iframe.src = embedUrl;
        iframe.allow = 'autoplay; fullscreen; picture-in-picture';
        iframe.allowFullscreen = true;
        iframe.className = 'htb-video-modal__iframe';
        this.mediaEl.appendChild(iframe);
      } else {
        this._appendVideoEl(videoUrl);
      }
    } else if (videoFileUrl) {
      this._appendVideoEl(videoFileUrl);
    }

    this.hidden = false;
    document.body.style.overflow = 'hidden';
    this.querySelector('.htb-video-modal__close')?.focus();
  }

  close() {
    this.mediaEl.innerHTML = '';
    this.hidden = true;
    document.body.style.overflow = '';
  }

  _appendVideoEl(src) {
    const video = document.createElement('video');
    video.src = src;
    video.controls = true;
    video.autoplay = true;
    video.className = 'htb-video-modal__video';
    this.mediaEl.appendChild(video);
  }

  _embedUrl(url) {
    let m = url.match(/(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([\w-]+)/);
    if (m) return `https://www.youtube.com/embed/${m[1]}?autoplay=1&rel=0`;

    m = url.match(/vimeo\.com\/(\d+)/);
    if (m) return `https://player.vimeo.com/video/${m[1]}?autoplay=1`;

    return null;
  }
}

customElements.define('htb-video-modal', HtbVideoModal);

document.addEventListener('click', (e) => {
  const trigger = e.target.closest('[data-htb-video-trigger]');
  if (!trigger) return;
  const modal = document.getElementById(trigger.dataset.modalId);
  if (!modal) return;
  modal.open(trigger.dataset.videoUrl || '', trigger.dataset.videoFile || '');
});
